// import media files
import EducationImg1 from 'assets/images/education/edu-img-1.jpg';
import EducationImg2 from 'assets/images/education/edu-img-2.jpg';
import EducationImg3 from 'assets/images/education/edu-img-3.jpg';
import EducationImg4 from 'assets/images/education/edu-img-4.jpg';
import EducationImg5 from 'assets/images/education/edu-img-5.jpg';
import EducationImg6 from 'assets/images/education/edu-img-6.jpg';
import EducationImg7 from 'assets/images/education/edu-img-7.jpg';
import EducationImg8 from 'assets/images/education/edu-img-8.jpg';

export const SkillCoursesData = [
	{
		id: 1,
		category: 'Writing',
		image: EducationImg1,
        duration: 8,
        durationUnit: 'Hours',
		title: 'Content Writing',
		rating: 4.9,
		votes: 31,
	},
	{
		id: 2,
		category: 'Design',
		image: EducationImg2,
		duration: 12,
        durationUnit: 'Hours',
		title: 'UI / UX Design',
		rating: 4.9,
		votes: 23
	},
	{
		id: 3,
		category: 'Development',
		image: EducationImg3,
		duration: 2,
        durationUnit: 'Hours',
		title: 'Coding and Development',
		rating: 5.0,
		votes: 6380
	},
	{
		id: 4,
		category: 'Photography',
		image: EducationImg4,
		duration: 12,
        durationUnit: 'Hours',
		title: 'Photography Courses',
		rating: 5.0,
		votes: 221
	},
	{
		id: 5,
		category: 'Financial',
		image: EducationImg5,
		duration: 9,
        durationUnit: 'Hours',
		title: 'Financial Planning',
        rating: 4.9,
		votes: 76
	},
	{
		id: 6,
		category: 'Marketing ',
		image: EducationImg6,
		duration: 2,
        durationUnit: 'Hours',
		title: 'Content Marketing 201',		
		rating: 4.9,
		votes: 43
	},
	{
		id: 7,
		category: 'Language',
		image: EducationImg7,
		duration: 2,
        durationUnit: 'Weeks',
		title: 'Learn a Language',		
		rating: 5.0,
		votes: 34
	},
	{
		id: 8,
		category: 'Health',
		image: EducationImg8,
		duration: 3,
        durationUnit: 'Weeks',
		title: 'Health Wellness',		
		rating: 4.7,
		votes: 75
	}
];

export default SkillCoursesData;
